<template>
  <div class="dsf-sc-survey-project-list">

    <el-table
      :data="list"
      height="560px"
      style="width: 100%"
      
    >
      <el-table-column
        prop="name"
        label="调查项目"
        class-name="dsfa-sc-area-survey-list-dialog-name"
      >
      </el-table-column>
      <el-table-column
        prop="date"
        label="填报日期"
        align="center"
        header-align="center"
        width="140px"
      >
      </el-table-column>
    </el-table>

  </div>
</template>

<script>
export default {
  name: "DSFSCSurveyProjectList",
  data() {
    return {
      list: [],
    };
  },
  created() {
    this.$http
      .get("/static/data/dsf.scsurveyprojectlist.json")
      .then(({ data }) => {
        this.list = data.list || [];
      });
  },
};
</script>

<style>
</style>